<template>
    <div>
        <!-- <check-Remark v-if="checkStatu==2  && !isRegister"></check-Remark> -->
        <div id="merchantInfo"  v-if="checkStatu!=2">
            <div class="historytop" v-if="id && !isRegister">
                <div style="line-height:27px">
                    <i class="prev_page lf" @click="$router.history.go(-1)"></i>
                    <i style="color: #969899">历史修改详情</i>
                </div>
                <el-breadcrumb separator="/" style="height:27px;margin-top:5px">
                    <el-breadcrumb-item :to="{ path: '/setting/merchant/merchantHistory' }">历史修改记录</el-breadcrumb-item>
                    <el-breadcrumb-item>历史修改详情</el-breadcrumb-item>			
                </el-breadcrumb>
            </div>
            <div class="title" style="position: relative;">
                <i class="iconfont icon-fillinformation_shopinfo font_style" style="display: inline-block;"></i>
                服务商信息
                <div id="history" @click="gohistory" v-if="!id && !isRegister">
                    <span>
                    历史修改记录
                    </span>
                    <img src="../../../assets/img/icon/Group 8.png" alt="#">
                </div>
            </div>
            <div class="info" style="padding-bottom:20px;">
                <el-tabs class="tabs" >
                        <el-tab-pane v-for="(item,index) in parkList" :key="index">
                            <span slot="label"  class="line-through" v-if="item.dataType == 3">{{ `${item.parkName}(已删除)` }}</span>
                            <span slot="label" v-else>{{ item.parkName }} <i class="red-font" v-if="item.dataType == 2">new</i></span>
                            <el-row style="margin-bottom: 10px" v-for="(shop, idx) in item.shopList" :key="idx">
                                <template v-if="idx == 0">
                                    <el-col :span="24" class="font_style" >
                                        <div>
                                            <el-col :span="5"><p style="float: right">服务商类别 &nbsp;&nbsp;</p></el-col>
                                            <el-col :span="7"><span>企业服务商</span></el-col>
                                        </div>
                                    </el-col>
                                    <el-col :span="12" class="font_style">
                                        <div class="clearfix_2">
                                            <el-col :span="10"><p style="float: right" :class="getclass(JSON.parse(item.shopList[0].lastDifInfo),'shopName')?'historyStyle':''">
                                                服务商店铺名称 &nbsp;&nbsp;</p></el-col>
                                            <el-col :span="14">
                                                <span v-text="item.shopList[0].shopName"></span>
                                                <div style="color: #C2C8CC;font-size: 14px;margin-top: 2px"
                                                    v-if="getclass(JSON.parse(item.shopList[0].lastDifInfo),'shopName')?true:false">
                                                    ({{JSON.parse(item.shopList[0].lastDifInfo)?JSON.parse(item.shopList[0].lastDifInfo).shopName:''}})
                                                </div>
                                            </el-col>
                                        </div>
                                        <div class="clearfix_2">
                                            <el-col :span="10"><p class="text-right" :class="getclass(JSON.parse(item.shopList[0].lastDifInfo),'shopAddress')?'historyStyle':''">服务商店铺地址 &nbsp;&nbsp;</p></el-col>
                                            <el-col :span="14">
                                                <span v-text="item.shopList[0].shopAddress"></span>
                                                <div style="color: #C2C8CC;font-size: 14px;margin-top: 2px"
                                                    v-if="getclass(JSON.parse(item.shopList[0].lastDifInfo),'shopAddress')?true:false">
                                                    ({{JSON.parse(item.shopList[0].lastDifInfo)?JSON.parse(item.shopList[0].lastDifInfo).shopAddress:''}})
                                                </div>
                                            </el-col>
                                        </div>
                                        <div  class="clearfix_2">
                                            <el-col :span="10"><p style="float: right"
                                            :class="getclass(JSON.parse(item.shopList[0].lastDifInfo),'managerIdentityAccessory')?'historyStyle':''"
                                                                >
                                                服务商店铺负责人身份证正面照 &nbsp;&nbsp;</p></el-col>
                                            <el-col :span="14">
                                                <p class="picture" v-if="item.shopList[0].managerIdentityAccessory" @click="addpicture(item.shopList[0].managerIdentityAccessory)">
                                                    <img :src="item.shopList[0].managerIdentityAccessory" alt="#">
                                                    <span class="zzc"></span>
                                                </p>
                                            </el-col>
                                        </div>
                                    </el-col>
                                    <el-col :span="12" class="font_style">
                                        <div class="clearfix_2">
                                            <el-col :span="10"><p style="float: right"
                                                :class="getclass(JSON.parse(item.shopList[0].lastDifInfo),'contantMobile')?'historyStyle':''"
                                                                >
                                                服务商店铺电话 &nbsp;&nbsp;</p></el-col>
                                            <el-col :span="14"><span v-text="item.shopList[0].contantMobile"></span>
                                                <div style="color: #C2C8CC;font-size: 14px;margin-top: 2px"
                                                    v-if="getclass(JSON.parse(item.shopList[0].lastDifInfo),'contantMobile')?true:false">
                                                    ({{JSON.parse(item.shopList[0].lastDifInfo)?JSON.parse(item.shopList[0].lastDifInfo).contantMobile:''}})
                                                </div>
                                            </el-col>
                                        </div>
                                        <div  class="clearfix_2">
                                            <el-col :span="10"><p style="float: right"
                                                :class="getclass(JSON.parse(item.shopList[0].lastDifInfo),'managerIdentityNo')?'historyStyle':''">
                                                服务商店铺负责人身份证号 &nbsp;&nbsp;</p></el-col>
                                            <el-col :span="14"><span v-text="item.shopList[0].managerIdentityNo"></span>
                                                <div style="color: #C2C8CC;font-size: 14px;margin-top: 2px"
                                                    v-if="getclass(JSON.parse(item.shopList[0].lastDifInfo),'managerIdentityNo')?true:false">
                                                    ({{JSON.parse(item.shopList[0].lastDifInfo)?JSON.parse(item.shopList[0].lastDifInfo).managerIdentityNo:''}})
                                                </div>
                                            </el-col>
                                        </div>
                                        <div class="clearfix_2">
                                            <el-col :span="10"><p style="float: right"
                                            :class="getclass(JSON.parse(item.shopList[0].lastDifInfo),'managerIdentityAccessoryBack')?'historyStyle':''"
                                                                >
                                                服务商店铺负责人身份证反面照 &nbsp;&nbsp;</p></el-col>
                                            <el-col :span="14">
                                                <p class="picture"  v-if="item.shopList[0].managerIdentityAccessoryBack" @click="addpicture(item.shopList[0].managerIdentityAccessoryBack)">
                                                    <img :src="item.shopList[0].managerIdentityAccessoryBack" alt="#">
                                                    <span class="zzc"></span>
                                                </p>
                                            </el-col>
                                        </div>
                                    </el-col>
                                </template>
                            </el-row>
                        </el-tab-pane>
                </el-tabs>
            </div>
            <div class="title" style="margin-top:20px;">
                <i class="iconfont icon-fillinformation_enterpriseInformation font_style" style="display: inline-block;"></i>
                服务商信息
            </div>
            <div class="info" style="padding-top:20px;padding-bottom:20px;">
                <el-row style="margin-bottom: 10px;margin-top: 20px">
                <el-col :span="12" class="font_style">
                    <div class="clearfix_2">
                        <el-col :span="10"><p style="float: right" :class="getstyle('companyName')?'historyStyle':''">服务商名称
                            &nbsp;&nbsp;</p></el-col>
                        <el-col :span="14">
                            <span>{{dataList.companyName}}</span>
                            <div style="color: #C2C8CC;font-size: 14px;margin-top: 2px" v-if="getstyle('companyName')">
                                ({{lastDifInfo.companyName}})
                            </div>
                        </el-col>
                    </div>
                    <div class="clearfix_2">
                        <el-col :span="10"><p style="float: right" :class="getstyle('businessCardNo')?'historyStyle':''">
                            社会信用代码 &nbsp;&nbsp;</p></el-col>
                        <el-col :span="14">
                            <span>{{dataList.businessCardNo}}</span>
                            <div style="color: #C2C8CC;font-size: 14px;margin-top: 2px" v-if="getstyle('businessCardNo')">
                                ({{lastDifInfo.businessCardNo}})
                            </div>
                        </el-col>
                    </div>
                    <div class="clearfix_2">
                        <el-col :span="10"><p style="float: right" :class="getstyle('companyAddress')?'historyStyle':''">
                            服务商地址 &nbsp;&nbsp;</p></el-col>
                        <el-col :span="14">
                            <span>{{dataList.companyAddress}}</span>
                            <div style="color: #C2C8CC;font-size: 14px;margin-top: 2px" v-if="getstyle('companyAddress')">
                                ({{lastDifInfo.companyAddress}})
                            </div>
                        </el-col>
                    </div>
                </el-col>
                <el-col :span="12" class="font_style">
                    <div class="clearfix_2">
                        <el-col :span="10"><p style="float: right" :class="getstyle('companyPhone')?'historyStyle':''">服务商电话
                            &nbsp;&nbsp;</p></el-col>
                        <el-col :span="14"><span>{{dataList.companyPhone}} &nbsp;&nbsp;</span>
                            <div style="color: #C2C8CC;font-size: 14px;margin-top: 2px" v-if="getstyle('companyPhone')">
                                ({{lastDifInfo.companyPhone}})
                            </div>
                        </el-col>
                    </div>
                    <div class="clearfix_2">
                        <el-col :span="10"><p style="float: right"
                                            :class="getstyle('businessCardAccessory')?'historyStyle':''">营业执照
                            &nbsp;&nbsp;</p></el-col>
                        <el-col :span="14">
                            <p class="picture" @click="addpicture(dataList.businessCardAccessory)">
                                <img :src="dataList.businessCardAccessory" alt="#">
                                <span class="zzc"></span>
                            </p>
                        </el-col>
                    </div>
                </el-col>
            </el-row>
            </div>
            <div class="title" style="margin-top:20px;">
                <i style="display: inline-block;">
                    <img src="../../../assets/img/icon/openbank.png" alt="#">
                </i>
                开户行信息
            </div>
            <div class="info" style="padding-top:20px;padding-bottom:20px;">
                <el-row style="margin-bottom: 10px;margin-top: 15px">
                    <el-col :span="12" class="font_style">
                        <div class="clearfix_2">
                            <el-col :span="10"><p style="float: right">银行账户类型 &nbsp;&nbsp;</p></el-col>
                            <el-col :span="14">
                                <span v-if="dataList.bankCardType == 1">对公账户</span>
                                <span v-if="dataList.bankCardType == 2">对私账户</span>
                            </el-col>
                        </div>
                        <div class="clearfix_2">
                            <el-col :span="10"><p style="float: right" :class="getstyle('bankStationName')?'historyStyle':''">
                                开户行名称 &nbsp;&nbsp;</p></el-col>
                            <el-col :span="14">
                                <span>{{dataList.bankStationName}}</span>
                                <div style="color: #C2C8CC;font-size: 14px;margin-top: 2px" v-if="getstyle('bankStationName')">
                                    ({{lastDifInfo.bankStationName}})
                                </div>
                            </el-col>
                        </div>
                        <div class="clearfix_2">
                            <el-col :span="10"><p style="float: right" :class="getstyle('bankName')?'historyStyle':''">银行名称
                                &nbsp;&nbsp;</p></el-col>
                            <el-col :span="14"><span>{{dataList.bankName}} &nbsp;&nbsp;</span>
                                <div style="color: #C2C8CC;font-size: 14px;margin-top: 2px" v-if="getstyle('bankName')">
                                    ({{lastDifInfo.bankName}})
                                </div>
                            </el-col>
                        </div>
                    </el-col>
                    <el-col :span="12" class="font_style">
                        <div class="clearfix_2">
                            <el-col :span="10"><p style="float: right" :class="getstyle('bankCity')?'historyStyle':''">开户行所在地区
                                &nbsp;&nbsp;</p></el-col>
                            <el-col :span="14">
                                <span>{{dataList.bankProvince}}{{dataList.bankCity}}</span>
                                <div style="color: #C2C8CC;font-size: 14px;margin-top: 2px" v-if="getstyle('bankCity')">
                                    ({{lastDifInfo.bankProvince}}{{lastDifInfo.bankCity}})
                                </div>
                            </el-col>
                        </div>
                        <div class="clearfix_2">
                            <el-col :span="10"><p style="float: right" :class="getstyle('bankCardNo')?'historyStyle':''">对公账号
                                &nbsp;&nbsp;</p></el-col>
                            <el-col :span="14"><span>{{dataList.bankCardNo}} &nbsp;&nbsp;</span>
                                <div style="color: #C2C8CC;font-size: 14px;margin-top: 2px" v-if="getstyle('bankCardNo')">
                                    ({{lastDifInfo.bankCardNo}})
                                </div>
                            </el-col>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="title" style="margin-top:20px;">
                <i class="iconfont icon-fillinformation_legalperson font_style" style="display: inline-block;"></i>
                法人信息
            </div>
            <div class="info" style="padding-top:20px;padding-bottom:20px;margin-bottom:60px;">
                <el-row style="margin-bottom: 40px">
                    <el-col :span="12" class="font_style">
                        <div class="clearfix_2">
                            <el-col :span="10"><p style="float: right" :class="getstyle('legalName')?'historyStyle':''">法人姓名
                                &nbsp;&nbsp;</p></el-col>
                            <el-col :span="14"><span>{{dataList.legalName}}</span>
                                <div style="color: #C2C8CC;font-size: 14px;margin-top: 2px" v-if="getstyle('legalName')">
                                    ({{lastDifInfo.legalName}})
                                </div>
                            </el-col>
                        </div>
                        <div class="clearfix_2">
                            <el-col :span="10"><p style="float: right" :class="getstyle('legalIdentityNo')?'historyStyle':''">
                                法人身份证号码 &nbsp;&nbsp;</p></el-col>
                            <el-col :span="14"><span>{{dataList.legalIdentityNo}}</span>
                                <div style="color: #C2C8CC;font-size: 14px;margin-top: 2px" v-if="getstyle('legalIdentityNo')">
                                    ({{lastDifInfo.legalIdentityNo}})
                                </div>
                            </el-col>
                        </div>
                        <div class="clearfix_2">
                            <el-col :span="10"><p style="float: right" :class="getstyle('legalIdentityAccessory')?'historyStyle':''">法人身份证正面照 &nbsp;&nbsp;</p></el-col>
                            <el-col :span="14">
                                <p class="picture" @click="addpicture(dataList.legalIdentityAccessory)">
                                    <img :src="dataList.legalIdentityAccessory" alt="#">
                                    <span class="zzc"></span>
                                </p>
                            </el-col>
                        </div>
                    </el-col>
                    <el-col :span="12" class="font_style">
                        <div class="clearfix_2">
                            <el-col :span="10"><p style="float: right" :class="getstyle('legalMobile')?'historyStyle':''">法人手机号码
                                &nbsp;&nbsp;</p></el-col>
                            <el-col :span="14"><span>{{dataList.legalMobile}}</span>
                                <div style="color: #C2C8CC;font-size: 14px;margin-top: 2px" v-if="getstyle('legalMobile')">
                                    ({{lastDifInfo.legalMobile}})
                                </div>
                            </el-col>
                        </div> 
                        <div class="clearfix_2">
                            <el-col :span="10"><p style="float: right"
                                                :class="getstyle('legalMobile')?'historyStyle':''">法人身份证反面照
                                &nbsp;&nbsp;</p></el-col>
                            <el-col :span="14">
                                <p class="picture" @click="addpicture(dataList.legalIdentityAccessoryBack)">
                                    <img :src="dataList.legalIdentityAccessoryBack" alt="#">
                                    <span class="zzc"></span>
                                </p>
                            </el-col>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <!-- 放大图片 -->
            <div class="bigpicture" style="z-index:2000;background:rgba(0,0,0,0.5)" v-if="showpicture" @click="xiaoshi">
                <div class="picturebox" ref="picturebox"  @click.stop="">
                    <img :src="src" alt="#">
                </div>
            </div>
            <!-- <template v-if="!isRegister">
                <div class="footer" v-if="checkStatu>1">
                    <el-button class="btnNew btnSize btn" @click="Upt">重新编辑</el-button>
                </div>
            </template> -->
            <!-- <div class="footer" v-if="checkStatu==1">
                <el-button class="btnNew btnSize btn" @click="awai">等待审核</el-button>
            </div> -->
        </div>
    </div>
</template>

<script>
import API from '@/fetch/api'
import * as access from "@/config/access";
import { checkStatus } from '@/common/util/constans'
// import checkRemark from './checkRemark'

export default {
    props:['isRegister'],
    // components: {checkRemark},
    data(){
        return {
            checkStatu: null,
            showpicture:false,
            id:'',
            src:'',
            parkList:[],
            dataList:[],
            lastDifInfo:''
        }
    },
    mounted () {
        this.getdetails ()
    },
    methods:{
        // checkRemark () {
        //     this.$router.push({
        //         name: 'checkRemark',
        //         query: {
        //         }
        //     })
        // },
        getdetails () {
            this.id = this.$route.query.id
            if(this.id){
                API.http({
                    fullUrl: '/merchant/history_info/detail',
                    type:'GET',
                    params:{
                        id:this.id
                    }
                }).then(res=>{
                    if(res.code==200){
                        this.dataList = res.data
                        this.parkList = res.data.parkList
                        if(res.data.lastDifInfo){
                            this.lastDifInfo = JSON.parse(res.data.lastDifInfo)
                        }else{
                            this.lastDifInfo = null
                        }
                    }
                })
            }else{
                API.http({
                    fullUrl: '/merchant/audit_info',
                    type:'POST',
                }).then(res=>{
                    if(res.code==200){
                        if(res.data.lastDifInfo){
                            this.lastDifInfo = JSON.parse(res.data.lastDifInfo)
                        }else{
                            this.lastDifInfo = null
                        }
                        this.dataList = res.data
                        this.parkList = res.data.parkList
                        access.session('checkStatus', res.data.checkStatus)
                        access.session('checkStatusC', checkStatus[String(res.data.checkStatus)]); //审核状态名称
                        this.checkStatu = access.session('checkStatus')
                        this.$emit('refrashStatus');
                    }
                })
            }
            
        },
        xiaoshi () {
            this.showpicture = false
        },
        addpicture (url) {
            if(!url) return
            this.src = url
            this.showpicture = true
        },
        // Upt () {
        //     this.$router.push({
        //         name: 'merchantUpt',
        //         query: {
        //         id: 12345
        //         }
        //     })
        // },
        gohistory () {
            this.$router.push({
                name: 'merchantHistory',
                query: {
                id: 12345
                }
            })
        },
        getclass (info,name) {
            if(info){
                if(info[name]){
                    return true
                }
            }else{
                return false
            }
        },
        getstyle (name) {
            if(this.lastDifInfo){
                if(this.lastDifInfo[name]){
                    return true
                }
            }else{
                return false
            }
        },
    }
}
</script>

<style lang="scss" scoped>
    #merchantInfo{
        .historytop{
            height: 40px;
            // background-color: #fff;
            border-radius: 4px;
            margin-bottom: 20px;
            display: flex;
            flex-direction:row;
            align-items:center;
            justify-content:space-between;
        }
        .title{
            color: #1AB394;
            font-size: 16px;
            font-weight:600;
            margin-bottom: 11px;
            #history{
                position: absolute;
                top: 0;
                right:0;
                font-size: 14px;
                cursor:pointer;
            }
        }
        .info{
            font-size:14px;
            padding-left: 10px;
            background-color: #fff;
            border-radius: 4px;
            .font_style {
                div {
                    line-height: 34px;
                }

                p {
                    color: #676A6C;
                    font-size: 14px;
                }

                span {
                    color: #303233;
                    font-size: 14px;
                }
            }
        .img_style {
            width: 100px;
            height: 100px;
            position: relative;
            top: -12px;
        }
        .historyStyle {
            color: #ff4064 !important;
        }
        .picture{
            position: relative;
            width: 100px;
            height: 100px;
            border: 1px solid #C2C8CC;
            border-radius: 8px;
            img{
                width: 100%;
                height: 100%;
                border-radius: 8px;
            }
            .zzc{
                position: absolute;
                width: 100px;
                height: 100px;
                background:url(../../../assets/img/icon/fdj.png) no-repeat center;
                background-color: rgba(0,0,0,.5);
                opacity: 0;
                border-radius: 8px;
                top:50;
                left:0;
                cursor:pointer;
            }
            .zzc:hover{
                opacity: 1;
                transition:0.3s;
            }
        }
        }
        .bigpicture{
            width: 100%;
            height: 100%;
            position:fixed;
            top:0;
            left:0;
            display: flex;
            align-items: center;
            justify-content: center;
            .picturebox{
                width: 600px;
                height: 400px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .footer{
            width:calc(100% - 220px);
            position: fixed;
            bottom:0;
            background-color: #fff;
            margin-left: -20px;
            height: 60px;
            line-height: 60px;
            text-align: center;
            .redbtn{
                background-color:#f56c6c;
                color: #fff;
            }
        }
    }
</style>